import state from './Customer/states'
import mutations from './Customer/mutations'
import actions from './Customer/actions'
import getters from './Customer/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
